<div class="editor-wrapper" [class.readonly]="readonly" [class.invalid]="invalid">

  <!-- Toolbar -->
  <div class="toolbar" role="toolbar" aria-label="Text formatting toolbar">

    <!-- Text Formatting -->
    <div class="toolbar-group" aria-label="Text formatting">
      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('bold')" title="Bold">
        <rds-icon namespace="filled" icon="text_bold"></rds-icon>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('italic')" title="Italic">
        <rds-icon namespace="filled" icon="text_italic"></rds-icon>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('underline')" title="Underline">
        <rds-icon namespace="filled" icon="text_underline"></rds-icon>
      </button>
    </div>

    <!-- Lists -->
    <div class="toolbar-group" aria-label="Lists">
      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('insertUnorderedList')" title="Bullet list">
        <rds-icon namespace="filled" icon="list"></rds-icon>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('insertOrderedList')" title="Numbered list">
        <rds-icon namespace="filled" icon="list_numbered"></rds-icon>
      </button>
    </div>

    <!-- Indentation -->
<!--    <div class="toolbar-group" aria-label="Indentation">-->
<!--      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('indent')" title="Indent">-->
<!--        <rds-icon namespace="filled" icon="indent_increase"></rds-icon>-->
<!--      </button>-->
<!--      <button type="button" (mousedown)="$event.preventDefault()" (click)="format('outdent')" title="Outdent">-->
<!--        <rds-icon namespace="filled" icon="indent_decrease"></rds-icon>-->
<!--      </button>-->
<!--    </div>-->

    <!-- Clipboard & History -->
    <div class="toolbar-group" aria-label="Clipboard and history">
      <button type="button" (mousedown)="$event.preventDefault()" (click)="cut()" title="Cut">
        <rds-icon namespace="filled" icon="cut"/>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="copy()" title="Copy">
        <rds-icon namespace="filled" icon="copy"/>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="paste()" title="paste">
        <rds-icon namespace="filled" icon="paste"/>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="undo()" title="Undo">
        <rds-icon namespace="filled" icon="undo"/>
      </button>
      <button type="button" (mousedown)="$event.preventDefault()" (click)="redo()" title="Redo">
        <rds-icon namespace="filled" icon="redo"/>
      </button>
    </div>

  </div>

  <!-- Editable content -->
  <div #editor
       class="editor-content rds-form-field__control"
       role="textbox"
       aria-multiline="true"
       [attr.contenteditable]="!readonly"
       [attr.data-placeholder]="placeholder"
       [style.min-height.px]="minHeight"
       [style.height.px]="minHeight >= 400 ? minHeight : null"
       (input)="onInput()"
       (blur)="markAsTouched()">
  </div>

</div>
